import React from "react";

import PageMeta from "core/PageMeta";
import SectionContainer from "core/SectionContainer";
import HeaderSearch from "core/SiteHeader/HeaderSearch";
import Hero from "core/Hero";
import Collections from "core/Collections";
import BlogPosts from "core/BlogPosts";
import Promo from "core/Promo";

import colors from "core/colors";

import {
    heroTitle,
    heroSvgDesktop,
    heroSvgMobile,
    collectionsTitle,
    collections,
    recentPostsTitle,
    recentPosts,
    promo
} from "./data";

const HomeNP = () => {
    return (
        <>
            <PageMeta
                title="Noun Project: Free Icons & Stock Photos for Everything"
                removeDescriptionTag
            >
                <meta
                    name="description"
                    content="Noun Project features the most diverse collection of icons and stock photos ever. Download SVG and PNG. Browse over 3 million art-quality icons and photos."
                />
            </PageMeta>

            <SectionContainer
                bgColor={colors.midnight}
                textColor={colors.mist}
                isHero
                removeLeftRightPadding
            >
                <Hero
                    title={heroTitle}
                    desktopSvgUrl={heroSvgDesktop}
                    mobileSvgUrl={heroSvgMobile}
                    search={<HeaderSearch />}
                    headingColor={colors.snow}
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.mist}>
                <Collections
                    title={collectionsTitle}
                    collections={collections}
                />
            </SectionContainer>

            <SectionContainer>
                <BlogPosts
                    blogPostsTitle={recentPostsTitle}
                    posts={recentPosts}
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.mist}>
                <Promo promoContent={promo} />
            </SectionContainer>
        </>
    );
};

export default HomeNP;
